/** Origins of candidacies coming from a CVthèque (lowercase) */
const CVTHEQUE_ORIGINS = ['cvaden', 'hellowork', 'apec']

/**
 * Check if a candidacy origin is a CVthèque.
 * The origin must be strictly equal (ignoring case and surrounding spaces):
 * "EMAIL_RETOUR_ANNONCE: Hellowork De Graet" is a job board answer, not a CVthèque.
 * Must stay in sync with back/src/_utils/functions/is-cvtheque-origin.ts
 * @param {string} origin Origin
 * @returns {boolean} Result
 */
export default function isCvthequeOrigin(origin) {
    return CVTHEQUE_ORIGINS.includes(origin?.trim().toLowerCase())
}
